import { useTranslation } from 'react-i18next';
import { useOnline } from './useOnline';

/**
 * The offline honesty bar (PLAN §Offline — "this is where a PWA usually lies").
 *
 * Shown app-wide the instant the device goes offline. It is deliberately NOT a
 * subtle badge: a full-width solid amber bar a customer cannot miss, stating in
 * words that what they see is last-known and not live. On the live map this pairs
 * with the per-vehicle "last position HH:MM" line and the forced past-tense
 * markers, so nothing on screen claims to be current while we are offline.
 *
 * Amber (warn), not red (error): being offline is a state, not a fault. The dot
 * and copy read as "heads up", the way the map's degraded banner does.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnline();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 bg-raad-warn px-3 py-2 text-center text-[12.5px] font-semibold text-raad-onprimary"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
        <path d="M1 1l22 22" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <path d="M12 20h.01" />
      </svg>
      <span>{t('offline.bar')}</span>
    </div>
  );
}
